<template>
  <modal
      :name="modalTitle"
      :adaptive="true"
      height="auto"
      :width="500"
      transition="linear"
      :delay="0.15"
      class="export-calendar"
  >
    <modals-header
        :modalNameProp="modalTitle"
        @hideModalProp="hideModal"
    >
    </modals-header>

    <hr class="v--modal-hr">

    <children-checklist
        :items="childrenProp"
        :placeholder="$lang.messages.selectChildren"
        :option="childrenProp"
        :name="'children'"
        @optionChanged="onSelectedChildren"
        :validateProp="validateProp"
        :key="rerenderChecklist"
        ref="childrenChecklist" />

    <div class="url">
      <p>{{ $lang.messages.exportCalendarFp }}.</p>
      <div>
        <input
          type="text"
          name="description"
          class="input"
          :placeholder="$lang.messages.exportCalendar"
          v-model="calendarUrl"
          readonly="readonly"
          disabled="disabled"
          ref="exportCalendar"
        />
        <img src="@/assets/images/copy_ico.png" alt="" @click="copyToClipboard"/>
      </div>
    </div>
  </modal>
</template>

<script>
    import modalsHeader from '@/components/common/modals/ModalsHeader';
    import ChildrenChecklist from '@/components/common/ChildrenChecklist';
    import { mapActions } from 'vuex';
    import { EXPORT_CALENDAR } from '@/store/action.types';
    import STATUS_CODES from "@/common/statusCodes";

    export default {
        name: "FPExportCalendar",
        components: {
            'modals-header': modalsHeader,
            ChildrenChecklist
        },
        props: {
            modalTitle: {
                type: String,
                required: false,
                default: () => ''
            },
            childrenList: {
                type: Array,
                required: true,
                default: () => {
                    return [];
                }
            }
        },
        data() {
          return {
              calendarUrl: '',
              childrenProp: this.childrenList,
              validateProp: false,
              rerenderChecklist: 0,
          }
        },
        computed: {
            childrenGuids: function() {
                let rtrnArr = [];
                this.childrenList.forEach(child => {
                    rtrnArr.push(child.childGuid);
                });

                return rtrnArr;
            }
        },
        watch: {
            childrenList: function (val) {
                let rtrnArr = [];
                val.forEach(child => {
                  let newChild = this.$parent.clone(child)
                  newChild.clicked = true;
                  rtrnArr.push(newChild);
                });

                this.childrenProp = rtrnArr;
            }
        },
        methods: {
            ...mapActions({
                exportCalendarAction: EXPORT_CALENDAR,
            }),
            show() {
                this.$modal.show(this.modalTitle);
                this.exportCalendar(this.childrenGuids);
            },
            hideModal() {
                this.$modal.hide(this.modalTitle)
            },
            onSelectedChildren(results) {
                let rtrnArr = [];
                results.forEach(child => {
                    if (child.clicked) {
                        rtrnArr.push(child.childGuid);
                    }
                });
                this.exportCalendar(rtrnArr);
            },
            exportCalendar(children) {
                this.exportCalendarAction({
                    childrenGuids: children
                }).then(response => {
                    this.calendarUrl = response.data.data;
                }).catch(error => {
                    if (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402) {
                        this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
                    }
                })
            },
            copyToClipboard() {
                this.copyStringToClipboard(this.calendarUrl);
                this.$snotify.success('Copied URL to clipboard!', 'SUCCESS');
            },

            //function gotten from: https://techoverflow.net/2018/03/30/copying-strings-to-the-clipboard-using-pure-javascript/
            copyStringToClipboard (str) {
              // Create new element
              let el = document.createElement('textarea');
              // Set value (string to be copied)
              el.value = str;
              // Set non-editable to avoid focus and move outside of view
              el.setAttribute('readonly', '');
              el.style = { position: 'absolute', left: '-9999px' };
              document.body.appendChild(el);
              // Select text inside element
              el.select();
              // Copy text to clipboard
              document.execCommand('copy');
              // Remove temporary element
              document.body.removeChild(el);
          }
        }
    }
</script>
